import React from 'react';
import '../../css/Index.css';

const Index = () => {

    return (
        <div className="container">
            <div className="row">
                <div className="logo-container">
                    <div className="logo-content d-flex justify-content-center flex-wrap">
                        <span className="logo-letter" id="logo-L">L</span>
                        <span className="logo-letter" id="logo-I">I</span>
                        <span className="logo-letter" id="logo-G">G</span>
                        <span className="logo-letter" id="logo-A">A</span>
                        <span className="logo-letter" id="logo-I2">I</span>
                        <span className="logo-letter" id="logo-N">N</span>
                        <span className="logo-letter" id="logo-C">C</span>
                        <span className="logo-letter" id="logo-O">O</span>
                        <span className="logo-letter" id="logo-M">M</span>
                        <span className="logo-balloon">
                            <img src= 'https://grupo.us.es/ligaincom/public/uploads/images/comic.png' />
                        </span>
                    </div>
                </div>
                <div className="logotext text-center">
                <p className="logo-text">Liga de Investigación en Comunicación y Cultura. <br></br>
                    Género(s), Narrativa, Ideología y Estudios Visuales. <br /> Grupo PAIDI - SEJ694.</p>
                </div>
                <div className="d-flex justify-content-center mt-5 social-index">
                    <a href="https://www.instagram.com/ligaincom?igsh=MWJrZGlrYWlzcmhzZQ%3D%3D" target="blank"><i className="fa-brands fa-instagram instagram me-5"></i></a>
                    <a href="https://x.com/ligaincom" target="blank"><i className="fa-brands fa-x-twitter twitter ms-5"></i></a>
                </div>
            </div>
        </div>
    );
};

export default Index;
